import dayjs from 'dayjs';
import { UseFormReturn } from 'react-hook-form';

import {
  CacheKeysPreventaEnum,
  HorarioAgendamientoEnum,
  InstallScheduleData,
  useBlockManyHours,
  useUnblockManyHours,
} from '@/shared/actions/erp';
import { useSetCacheRedis } from '@/shared/actions/erp/global/cache-redis.actions';
import { CustomConfirmDialogProps } from '@/shared/components/ui/Dialogs';
import { AlertSeverityEnum,IDataPreventa } from '@/shared/interfaces';
import { useAuthStore } from '@/store/auth';
import { useGenericCountdownStore } from '@/store/erp';
import { useInstallScheduleStore } from '@/store/erp/planeacion';
import { Flota } from '@/shared/interfaces/erp/mantenimiento-operaciones';
import { texto } from '@/shared';

export type ConfirmHorarioInstallPreagendaModalProps = {
  flotaCode: string;
  flotaName: string;
  form: UseFormReturn<any>;

  isOpen: boolean;
  onClose: () => void;
  preventa: IDataPreventa;
  cackeKey: string;
};

const ConfirmInstallScheduleModal: React.FC<
  ConfirmHorarioInstallPreagendaModalProps
> = ({
  flotaCode,
  isOpen,
  onClose,
  preventa,
  flotaName,
  form,
  cackeKey = CacheKeysPreventaEnum.HORARIO_INSTALACION_PREAGENDA_BASE,
}) => {
  ///* global state -------------------
  const watchedFlotaRaw: Flota = form.watch('flotaRaw');

  ///* global state -------------------
  const selectedHour = useInstallScheduleStore(s => s.selectedHour);
  const selectedDate = useInstallScheduleStore(s => s.selectedDate);
  const userId = useAuthStore(s => s.user?.id);
  const setHasStartedTimer = useInstallScheduleStore(s => s.setHasStartedTimer);
  const startTimer = useGenericCountdownStore(s => s.start);
  const setIsFormBlocked = useInstallScheduleStore(s => s.setIsFormBlocked);
  const setDateTimeInstallation = useInstallScheduleStore(
    s => s.setDateTimeInstallation
  );
  const isVisibleCalendario = useInstallScheduleStore(
    s => s.isVisibleCalendario
  );
  const setSelectedHour = useInstallScheduleStore(s => s.setSelectedHour);

  ///* mutations -------------------
  const setCache = useSetCacheRedis<InstallScheduleData>({
    customSuccessMessage: 'Horario de instalación apartado durante 1 minuto',
  });
  const setCacheClear = useSetCacheRedis<InstallScheduleData>({
    customSuccessMessage: 'Tiempo agotado, seleccione nuevamente el horario',
    customMessageSuccessSeverityAlert: AlertSeverityEnum.info,
  });
  const tempBlockHourPlanificador = useBlockManyHours({
    enableRedirect: false,
    enableSuccessAlert: false,
  });
  const unBlockHours = useUnblockManyHours({
    enableRedirect: false,
    enableSuccessAlert: false,
  });

  ///* handlers -------------------
  const onSave = async () => {
    ///* temp block hour
    await tempBlockHourPlanificador.mutateAsync({
      id_preventa: preventa?.id_preventa!,
      flota: flotaCode,
      fecha: selectedDate!,
      horas: [+(selectedHour || 0)],
      tiempo: '00:10',
      motivo: 'Bloqueo temporal de horario de instalación',
    });

    /// set cache
    await setCache.mutateAsync({
      key: `${cackeKey}_${preventa?.id_preventa}`,
      value: {
        flotaCode,
        limitDate: dayjs()
          .add(HorarioAgendamientoEnum.initialCountMinutes, 'minutes')
          .format(),
        selectedDate: dayjs(selectedDate).format('YYYY-MM-DD'),
        preventaId: preventa?.id_preventa!,
        selectedHour: +(selectedHour || 0),
        userId: userId!,
        flotaName: watchedFlotaRaw?.nombre || flotaName,
        isVisibleCalendario: isVisibleCalendario,
      },
    });

    // start timer ------------
    startTimer(HorarioAgendamientoEnum.initialCountSeconds, async () => {
      useInstallScheduleStore.getState().clearAll();
      useInstallScheduleStore.getState().clearFinal();
      await setCacheClear.mutateAsync({
        key: `${cackeKey}_${preventa?.id_preventa}`,
        value: null,
      });
      await unBlockHours.mutateAsync({
        fecha: selectedDate!,
        horas: [+(selectedHour || 0)],
        flota: flotaCode,
      });

      form.setValue('flota', '');
      form.setValue('fecha_hora_instalacion', null);
      form.setValue('fecha_instalacion', null);
    }); // 10 minutes
    setHasStartedTimer(true);
    setIsFormBlocked(true);
    setDateTimeInstallation(
      dayjs(selectedDate)
        .hour(+(selectedHour || 0))
        .format()
    );

    onClose();
    setSelectedHour(selectedHour);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <CustomConfirmDialogProps
        open={isOpen}
        title="Seleccionar horario de instalación"
        subtitle="¿Está seguro de querer agendar la instalacion en este horario?"
        text2={texto.mensaje_bloquar_horario}
        confirmTextBtn="Si, seleccionar horario"
        onClose={handleClose}
        onConfirm={onSave}
      />
    </>
  );
};

export default ConfirmInstallScheduleModal;
